/**
 * Libs
 */

/**
 * Components
 */
import { FlexBox } from 'src/ui/common/atoms/flex-box';

/**
 * Utils
 */
import { media } from 'src/ui/common/mixins/media';
import styled, { css } from 'styled-components';

export const StyledFaqPageContentWrapper = styled(FlexBox)`
    background: ${({ theme }) => theme.colors.blue};
    padding: 20px 30px;
`;

export const StyledFaqPageContent = styled(FlexBox)``;

export const StyledFaqSection = styled.div`
    color: ${({ theme }) => theme.colors.white};
    scroll-margin-top: 40px;

    & > div > div {
        font-size: 16px;
        line-height: 130%;

        ${media.sm(css`
            font-size: 20px;
            line-height: 120%;
        `)}
    }

    h2 {
        font-size: 20px;
        line-height: 14s0%;
        position: relative;

        ${media.sm(css`
            font-size: 25px;
            text-align: center;
        `)}

        &:before {
            content: '';
            width: 8%;
            height: 2px;
            background: ${({ theme }) => theme.colors.softPurple};
            position: absolute;
            bottom: 0;
            -webkit-transition: all 0.3s ease;
            transition: all 0.3s ease;
        }
    }

    p {
        color: ${({ theme }) => theme.colors.white};
        line-height: 140%;
        margin: 0 0 20px;
    }

    a {
        color: ${({ theme }) => theme.colors.pink500};
    }

    li {
        font-size: 16px;
        line-height: 140%;
    }

    ol {
        padding: 0 0 0 20px;
    }

    ul {
        padding: 0 0 0 20px;

        li {
            p {
                margin: 0 0 20px;
            }
        }
    }

    &:not(:last-child) {
        margin: 0 0 40px;
    }
`;

export const StyledParagraph = styled.div`
    color: ${({ theme }) => theme.colors.white};
    font-size: 16px;
    margin: 0 0 20px;
`;

export const StyledList = styled.ul`
    color: ${({ theme }) => theme.colors.white};
    font-size: 16px;
    margin: 0 0 20px;
    padding: 0 0 0 20px;

    li {
        margin: 0 0 20px;
    }
`;

export const StyledListStep = styled.ol`
    font-size: 16px;
    list-style-type: none;
    counter-reset: elementcounter;
    color: ${({ theme }) => theme.colors.white};

    li {
        &:not(:last-child) {
            margin: 0 0 20px;
        }

        &::before {
            content: 'Step ' counter(elementcounter) '. ';
            counter-increment: elementcounter;
        }
    }
`;

export const StyledImageContainer = styled.div`
    display: flex;
    flex-direction: column;

    ${media.md(css`
        flex-direction: row;
        gap: 20px;
    `)}
`;

export const StyledImg = styled.img`
    display: block;
    width: 75%;
    margin: 0 auto 20px;

    ${media.md(css`
        margin: 0 0 20px;
        width: 50%;
    `)}
`;
